const {ImagePreviewer} = require('../imagePreviewer');
const {PdfPreviewer} = require('../pdfPreviewer');

export const FilePreviewers = {
  image: ImagePreviewer,
  pdf: PdfPreviewer,
};
